
import { MapPin, Star } from "lucide-react";

interface VacationInfoProps {
  vacation: any;
}

export const VacationInfo = ({ vacation }: VacationInfoProps) => {
  const vacationName = vacation.name || vacation.title || "Onbekende vakantie";
  const vacationStars = vacation.stars || null;
  const vacationRegion = vacation.region || vacation.city || null;
  const vacationCountry = vacation.country || null;
  const vacationDescription = vacation.description || vacation.descriptionLong || null;

  return (
    <div className="space-y-3">
      <h3 className="font-semibold text-lg line-clamp-2">{vacationName}</h3>
      
      {(vacationRegion || vacationCountry) && (
        <div className="flex items-center text-sm text-gray-600">
          <MapPin className="h-4 w-4 mr-1 flex-shrink-0" />
          <span>
            {vacationRegion && vacationCountry 
              ? `${vacationRegion}, ${vacationCountry}`
              : vacationRegion || vacationCountry
            }
          </span>
        </div>
      )}
      
      {vacationStars && (
        <div className="flex items-center">
          {[...Array(parseInt(vacationStars))].map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
          ))}
          <span className="ml-2 text-sm text-gray-600">{vacationStars} sterren</span>
        </div>
      )}
      
      {vacationDescription && (
        <p className="text-sm text-gray-600 line-clamp-3">{vacationDescription}</p>
      )}
    </div>
  );
};
